import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/site/Layout";
import PAGES from "@/config/pages.json";
import Home from "@/pages/Home";
import Tarifs from "@/pages/Tarifs";
import APropos from "@/pages/APropos";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
import Admin from "@/pages/Admin";
import { DemoModalProvider } from "@/components/site/DemoModal";

/* La liste des pages publiques vit dans src/config/pages.json : le routing
   ci-dessous ET le prerender SEO (scripts/prerender.js) en découlent.
   Ajouter une page = ajouter 1 ligne dans pages.json + son composant ici. */
const PAGE_ELEMENTS = {
  home: <Home />,
  tarifs: <Tarifs />,
  "a-propos": <APropos />,
  contact: <Contact />,
  "mentions-legales": <Legal kind="mentions" />,
  "politique-confidentialite": <Legal kind="privacy" />,
  cookies: <Legal kind="cookies" />,
};

const RootRedirect = () => {
  const nav = (navigator.language || "fr").slice(0, 2).toLowerCase();
  return <Navigate to={nav === "fr" ? "/fr" : "/en"} replace />;
};

/* Anciennes pages /solution* supprimées : redirection invisible vers l'accueil
   (évite tout 404 depuis les liens existants, ex. boutons de la Homepage). */
const SolutionRedirect = () => {
  const { lang } = useParams();
  return <Navigate to={`/${lang === "en" ? "en" : "fr"}`} replace />;
};

/* Ancienne page /contact/demo supprimée : la demande de démo se fait désormais
   via la modale globale. Redirection vers Contact pour les anciennes URL. */
const DemoPageRedirect = () => {
  const { lang } = useParams();
  return <Navigate to={`/${lang === "en" ? "en" : "fr"}/contact`} replace />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <DemoModalProvider>
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/:lang" element={<Layout />}>
              {PAGES.map((p) =>
                p.path === "" ? (
                  <Route key={p.key} index element={PAGE_ELEMENTS[p.key]} />
                ) : (
                  <Route key={p.key} path={p.path} element={PAGE_ELEMENTS[p.key]} />
                )
              )}
              <Route path="solution" element={<SolutionRedirect />} />
              <Route path="solution/*" element={<SolutionRedirect />} />
              <Route path="partenaires" element={<SolutionRedirect />} />
              <Route path="contact/demo" element={<DemoPageRedirect />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="*" element={<RootRedirect />} />
          </Routes>
        </DemoModalProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
